import CenterPanel from './CenterPanel.container'
export default CenterPanel
